import React, { useMemo, useState } from 'react';
import { Button, Form, Modal } from 'antd';

import { useDispatch } from 'react-redux';
import { doRetryOrderAddress } from '../../modules/orders/store/thunk';
import { FreeAddressInput } from '../Inputs/FreeAddressInput';
import { doFindAddress } from '../../modules/address/stores/thunk';

export const OrderAddressRetry = ({ order, close }) => {
  const dispatch = useDispatch();

  const open = useMemo(() => !!order, [order]);
  const [form] = Form.useForm();
  const [addressObject, setAddressObject] = useState(null);
  const [foundNothing, setFoundNothing] = useState(false);
  const [foundDifferent, setFoundDifferent] = useState(false);

  const select = (v) => {
    setAddressObject(v.addressObject);
  };

  const onFinish = async () => {
    const params = {
      orderId: order.orderId,
      deliveryAddress: addressObject,
    };
    try {
      await dispatch(doRetryOrderAddress(params));
      setAddressObject(null);
      setFoundNothing(false);
      setFoundDifferent(false);
      form.resetFields();
      close();
    } catch (e) {
      console.log(e.message);
      // no bother
    }
  };

  const cancel = () => {
    setAddressObject(null);
    setFoundNothing(false);
    setFoundDifferent(false);
    form.resetFields();
    close();
  };

  const validate = async () => {
    const address = {
      street: form.getFieldValue('street'),
      houseNumber: form.getFieldValue('houseNumber'),
      suffix: form.getFieldValue('suffix'),
      postalCode: form.getFieldValue('postalCode'),
      city: form.getFieldValue('city'),
      countryCode: form.getFieldValue('countryCode'),
    };
    const { payload } = await dispatch(doFindAddress(address));

    if (payload.street) {
      setAddressObject(payload);
      setFoundNothing(false);
      setFoundDifferent(false);
    } else {
      console.log('joe');
      setAddressObject(null);
      setFoundNothing(true);
    }
  };

  const find = async () => {
    const address = {
      street: form.getFieldValue('street'),
      houseNumber: form.getFieldValue('houseNumber'),
      suffix: form.getFieldValue('suffix'),
      postalCode: form.getFieldValue('postalCode'),
      city: form.getFieldValue('city'),
      countryCode: form.getFieldValue('countryCode'),
      skipCheck: 'all',
    };
    const { payload } = await dispatch(doFindAddress(address));
    if (payload) {
      setAddressObject(payload);
      setFoundNothing(false);
      setFoundDifferent(true);
    } else {
      setAddressObject(null);
      setFoundDifferent(false);
    }
  };

  return (
    <>
      <Modal open={open} title="Adjust address and retry order" width={600} onCancel={cancel}>
        <div style={{ paddingTop: 8 }}>
          <h5>Failing address:</h5>
          <p style={{ color: 'red' }}>{order?.deliveryAddress}</p>
        </div>
        <Form form={form} onFinish={onFinish} noValidate layout="vertical">
          <FreeAddressInput confirm={select} form={form} />

          {foundNothing && (
            <>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <p style={{ color: 'red' }}>Address could not be found...</p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="default" onClick={find}>
                  Show address that was found
                </Button>
              </div>
            </>
          )}
          {addressObject && (
            <>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 16 }}>
                <div>
                  <h4>Address found:</h4>
                  <p style={{ color: foundDifferent ? 'red' : 'green' }}>
                    {addressObject.street} {addressObject.houseNumber} {addressObject.suffix}
                  </p>
                  <p style={{ color: foundDifferent ? 'red' : 'green' }}>
                    {addressObject.postalCode} {addressObject.city}, {addressObject.countryCode}
                  </p>
                </div>
              </div>
            </>
          )}

          <Form.Item style={{ marginTop: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="default" onClick={validate} disabled={foundNothing}>
                Validate address
              </Button>
              <Button type="primary" htmlType="submit" disabled={!addressObject}>
                Retry order
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
